import styled from "styled-components";

export const StyledForm = styled.form`
  background-color: var(--color-gray-3);

  width: 100%;
  padding: 0rem 1rem;
  display: flex;
  flex-direction: column;

  gap: 1.5rem;

  h4 {
    text-align: center;
    font-weight: 700;
    font: 18px;
    line-height: 28px;
  }

  label {
    font-weight: 400;
    font-size: 12px;
  }

  .inputContent {
    position: relative;
    border: 1.2182px solid var(--color-gray-2);
    border-radius: 4px;
    background-color: var(--color-gray-2);
    width: 100%;
    font-weight: 400;
    font-size: 16.2426px;
    line-height: 26px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 4px;
    position: relative;
    padding: 0.2rem;

    &:focus-within {
      outline: 1px solid var(--color-gray-0);
    }

    &::before {
      margin: 15rem;
    }
  }

  p {
    font-size: 10px;
    top: 48px;
    left: 0;
    color: var(--color-gray-1);
  }

  input,
  select {
    background-color: transparent;
    border: 1px solid transparent;
    height: 100%;
    color: var(--color-gray-0);
    padding: 0.5rem;

    &:focus {
      outline: 0;
    }
  }

  input {
    width: 90%;
  }

  input::placeholder {
    color: var(--color-gray-1);
  }

  select {
    width: 100%;
  }

  select > option {
    background-color: var(--color-gray-3);
    color: var(--color-gray-1);
  }

  @media screen and (min-width: 475px) {
    width: 23.1rem;
  }
`;

export const StyledAlert = styled.div`
  position: absolute;
  background-color: var(--color-primary--negative);
  top: -12px;
  width: 12rem;
  height: 3rem;
  right: -204px;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 2px 10px;
  gap: 8px;

  p {
    color: #fff;
    margin-top: 2px;
    line-height: 15px;
  }

  &::before {
    content: "";
    border-style: solid;
    border-width: 10px 7px 0 7px;
    transform: rotate(90deg);
    border-color: var(--color-primary--negative) transparent;
    position: absolute;
    top: 17px;
    left: -7px;
  }

  svg {
    font-size: 14px;
    width: 14%;
  }
`;
